"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SUPPORT_ACTIONS;
(function(SUPPORT_ACTIONS) {
  SUPPORT_ACTIONS["DISABLE_WORKFLOW"] = "disableWorkflows";
  SUPPORT_ACTIONS["ENABLE_WORKFLOW"] = "enableWorkflows";
  SUPPORT_ACTIONS["CLONE"] = "clone";
  SUPPORT_ACTIONS["DISABLE_USER_WORKFLOW"] = "disableUserWorkflows";
  SUPPORT_ACTIONS["ENABLE_USER_WORKFLOW"] = "enableUserWorkflows";
  SUPPORT_ACTIONS["ENABLE_PERMISSION_MAIL"] = "enablePermissionMail";
  SUPPORT_ACTIONS["DISABLE_PERMISSION_MAIL"] = "disablePermissionMail";
})(
  (SUPPORT_ACTIONS = exports.SUPPORT_ACTIONS || (exports.SUPPORT_ACTIONS = {}))
);
//# sourceMappingURL=support.js.map
